import { createSlice } from '@reduxjs/toolkit'

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    searchFilters: null,
    fromDateFilter: null,
    toDateFilter: null,
    doSearch: false
  },
  reducers: {
    setSearch: (state, action) => {
      state.searchFilters = action.payload.searchFilters;
    },
    setFromDateFilter: (state, action) => {
      state.fromDateFilter = action.payload.fromDateFilter;
    },
    setToDateFilter: (state, action) => {
      state.toDateFilter = action.payload.toDateFilter;
    },
    setDoSearch: (state, action) => {
      state.doSearch = action.payload.doSearch;
    }
  },
})

export const { setSearch, setFromDateFilter, setToDateFilter, setDoSearch} = searchSlice.actions

export default searchSlice.reducer